import React from 'react';
import { sprintf } from 'sprintf';

import { SellingPoint } from 'components/SellingPoint';
import { SEDITION_USER_SLUG } from 'constants/global';

export const ArtStreamWelcome: React.FC<{}> = () => {
  return (
    <div>
      <div className='container'>
        <div className='mb-3'>
          <div className='text-center key-value__value mb-3'>3 Ways To Get Started</div>
          <div className='row'>
            <div className='col-12 col-sm mb-3 mb-sm-0'>
              <SellingPoint title='Explore Curated Playlists' icon='frame-artwork'>
                <span
                  dangerouslySetInnerHTML={{
                    __html: sprintf(
                      "To get you started we've added a few playlists to your Vault. Check them out and then visit official %sSedition profile%s to follow other curated playlists you may like.",
                      '<a href="' +
                        Routes.user_playlists_path(SEDITION_USER_SLUG) +
                        '" class="d-inline-block link-border">',
                      '</a>',
                    ),
                  }}
                />
                <div className='mt-1 mt-sm-2'>
                  <a
                    href={Routes.vault_playlists_path()}
                    className='btn btn--medium btn--border-dark'
                  >
                    Go to Playlists
                  </a>
                </div>
              </SellingPoint>
            </div>
            <div className='col-12 col-sm mb-3 mb-sm-0'>
              <SellingPoint title='Create Personal Playlists' icon='stacked-artworks'>
                Now you can create playlists from any artworks you like and enjoy them without
                watermarks. This can be done in your Vault or on any artwork page by using 'Add to
                Playlist'.
                <div className='mt-1 mt-sm-2'>
                  <a href={Routes.artworks_path()} className='btn btn--medium btn--border-dark'>
                    Browse Artworks
                  </a>
                </div>
              </SellingPoint>
            </div>
            <div className='col-12 col-sm mb-3 mb-sm-0'>
              <SellingPoint title='Change Your Settings' icon='settings'>
                Want to change Art Stream plans, update payment details or cancel your subscription?
                All these options are available in your account settings.
                <div className='mt-1 mt-sm-2'>
                  <a
                    href={Routes.account_art_streams_path()}
                    className='btn btn--medium btn--border-dark'
                  >
                    Manage Subscription
                  </a>
                </div>
              </SellingPoint>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
